import React, { useState } from "react";

const InputWithSuggestions = ({
    label,
    value,
    cssClass,
    onChange,
    options = [],
    optionKey = "name",
    onSelect,
    onCreate
}) => {
    const [showList, setShowList] = useState(false);

    const filtered = options.filter(item =>
        item[optionKey]
            .toLowerCase()
            .includes((value || "").toLowerCase())
    );

    return (
        <div style={{ position: "relative", width: "100%" }}>
            <input
                value={value || ""}
                placeholder={label}
                className={` ${cssClass} w-full`}
              
                onChange={(e) => {
                    onChange(e.target.value);
                    setShowList(true);
                }}
                onFocus={() => setShowList(true)}
                onBlur={() => setTimeout(() => setShowList(false), 200)}
                style={{
                    width: "100%",
                    padding: "5px",
                    border: "1px solid #ccc",
                    borderRadius: "4px"
                }}
            />

            {showList && (value || "") && (
                <div
                    style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        background: "#fff",
                        border: "1px solid #ddd",
                        zIndex: 999,
                        maxHeight: "180px",
                        overflowY: "auto"
                    }}
                >
                    {filtered.length > 0 ? (
                        filtered.map((item, idx) => (
                            <div
                                key={idx}
                                style={{
                                    padding: "8px",
                                    cursor: "pointer"
                                }}
                                onMouseDown={() => {
                                    onSelect?.(item);
                                    onChange(item[optionKey]);
                                    setShowList(false);
                                }}
                            >
                                {item[optionKey]}
                            </div>
                        ))
                    ) : (<div></div>
                        // <div
                        //     style={{
                        //         padding: "8px",
                        //         cursor: "pointer",
                        //         color: "blue"
                        //     }}
                        //     onMouseDown={() => {
                        //         onCreate?.(value);
                        //         setShowList(false);
                        //     }}
                        // >
                        //     ➕ Add "{value}"
                        // </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default InputWithSuggestions;